import React, { Component } from 'react';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import PropTypes from 'prop-types';
import SearchResultsCustomer from './SearchResultsCustomer/SearchResultsCustomer';
import './SearchResults.css';

class SearchResults extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isTransactionInfoHidden: false,
        }
    }

    toggleTransactionInfo = (e) => {
        this.setState({ isTransactionInfoHidden: e.target.checked });
        this.props.toggleTransactionInfo();
    }

    render() {
        return (
            <div className="showtix-search__results">
                <div className="showtix-section container">
                    <div className="row">
                        <div className="col-12">
                            <div className="x_table-responsive">
                                <table className="showtix-table showtix-table__striped">
                                    <thead>
                                        <tr>
                                            <th style={{ width: 20 }}>
                                                <div className="showtix-form__checkbox">
                                                    <input
                                                        type="checkbox"
                                                        className="showtix-input"
                                                        id="input-all"
                                                        value="true"
                                                        onChange={this.props.selectAllCheckboxes}
                                                    />
                                                    <label className="showtix-label" htmlFor="input-all"></label>
                                                </div>
                                            </th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody id="searchResultsTbl">
                                        { this.props.items.customers.map((customer, i) =>
                                            <SearchResultsCustomer 
                                                key={`customer-${i}`}
                                                client={this.props.items.client}
                                                user={this.props.items.user}
                                                events={this.props.items.events}
                                                customer={customer}
                                                isTransactionInfoHidden={this.state.isTransactionInfoHidden}
                                                updateSelectedIds={this.props.updateSelectedIds}
                                                toggleAlertModal={this.props.toggleAlertModal}
                                                toggleArchived={this.props.toggleArchived}
                                                toggleReleaseRefundModal={this.props.toggleReleaseRefundModal}
                                                setMessage={this.props.setMessage}
                                                printers={this.props.printers}
                                                currentPrinter={this.props.currentPrinter}
                                                printersBoca={this.props.printersBoca}
                                                currentPrinterBoca={this.props.currentPrinterBoca}
                                                handlePrinterChange={this.props.handlePrinterChange}
                                                handlePrinterChangeBoca={this.props.handlePrinterChangeBoca}
                                                printersStar={this.props.printersStar}
                                                printersStarUSB={this.props.printersStarUSB}
                                                currentPrinterStar={this.props.currentPrinterStar}
                                                handlePrinterChangeStar={this.props.handlePrinterChangeStar}
                                                eventsResults={this.props.eventsResults}
                                                isGodMode={this.props.isGodMode}
                                            />  
                                        )}
                                    </tbody>
                                </table>
                            </div>         
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

SearchResults.propTypes = {
    items: PropTypes.shape({
        transactions: PropTypes.array,
        user: PropTypes.object,
        updateSelectedIds: PropTypes.bool,
        toggleAlertModal: PropTypes.bool
    }),
    selectAllCheckboxes: PropTypes.func
}

export default SearchResults;


// WEBPACK FOOTER //
// ./src/components/Search/SearchResults/SearchResults.js